import { Text } from '@chakra-ui/react';
import Image from 'next/image';

export const ViewSectionAssociations = (props) => {
  const { profile } = props;
  const { associations } = profile;

  return (
    <div className='relative flex flex-col p-[30px] gap-5'>
      <Text textStyle="h3">Verified professional membership</Text>
      <div className='flex justify-between'>
        {associations?.map((asc) => asc.verified ? (
          <div key={asc.value} className='h-[100px] relative'>
            <Image height={100} width={100} style={{objectFit: 'contain'}} key={asc.value} alt={asc.label} src={asc.logo} className='h-[100px]' />
          </div>
        ) : null)}
      </div>
    </div>
  );
};
